import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/warning.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3fbf5e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "warning"
  })
], -1))
const _hoisted_3 = { class: "error-title" }
const _hoisted_4 = {
  key: 0,
  class: "error-subtitle"
}
const _hoisted_5 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.errorTitleText), 1)
    ]),
    (_ctx.errorDescriptionText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.errorDescriptionText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.closeButtonText)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "errorMessageCloseButton",
            class: "primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeButtonHandler && _ctx.closeButtonHandler(...args)), ["stop"]))
          }, _toDisplayString(_ctx.closeButtonText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}